package com.swetdot.swetgram.data.realtime

import com.swetdot.swetgram.data.api.ApiClient
import com.swetdot.swetgram.protocol.dto.RealtimeTokenResponse

/**
 * `POST /realtime/token` (operationId `createRealtimeToken`).
 *
 * Authenticated like any other call: the server derives the allowed channels from the caller's
 * own membership and signs them into the token, so the client never says which conversations it
 * wants -- it could not be believed if it did.
 */
class RealtimeRepository(private val api: ApiClient) : RealtimeTokenSource {
    override suspend fun issue(): RealtimeTokenResponse = api.post("realtime/token")
}
